import { Reveal } from "@/components/Reveal";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SuccessStoryCard } from "@/components/legacy/SuccessStoryCard";
import { images } from "@/data/images";
import { successStories } from "@/data/successStories";

export default function Legacy() {
  return (
    <div data-testid="legacy-page">
      {/* HERO */}
      <section className="relative pt-32 md:pt-44 pb-16 md:pb-24 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src={images.teamPhoto}
            alt=""
            className="w-full h-full object-cover opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-ink-base/80 via-ink-base/90 to-ink-base" />
        </div>
        <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
          <Reveal>
            <p className="label-eyebrow mb-4">The Impact</p>
            <h1 className="font-heading font-bold tracking-tighter leading-none text-6xl md:text-7xl lg:text-8xl text-white">
              Alumni
            </h1>
            <p className="mt-7 font-heading text-xl md:text-2xl lg:text-3xl font-light italic leading-snug text-zinc-300 max-w-3xl text-balance border-l-2 border-burnt pl-6">
              Success is something we define for ourselves. For me, it's staying
              curious through adversity, influencing lives on and off the court,
              developing leaders, and building relationships along the way.
              Championships are a goal, but they don't define success.
            </p>
          </Reveal>
        </div>
      </section>

      {/* SECTION 1 — COACHING IMPACT (STATS) and SECTION 2 — TESTIMONIALS are
          hidden until Coach provides verified numbers and real quotes. Code &
          data preserved in src/data/legacyStats.js, testimonials.js and their
          components (StatCard, TestimonialsCarousel) for future use.
          The "Athletes I've Coached" directory (AlumniGrid) was removed to avoid
          duplication; AlumniGrid + src/data/alumni.js are preserved for future use. */}

      {/* SECTION 4 — SUCCESS STORIES */}
      <section
        className="py-16 md:py-24 bg-ink-surface border-y border-white/10"
        data-testid="legacy-stories"
      >
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <Reveal>
            <p className="label-eyebrow mb-4">Former Players</p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-white">
              A Few of the Athletes I've Coached
            </h2>
            <p className="mt-4 text-zinc-400 max-w-2xl">
              A selection of alumni — the character, growth, and people behind the journey.
            </p>
          </Reveal>
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
            {successStories.map((story, i) => (
              <SuccessStoryCard key={story.id} story={story} delay={(i % 2) * 0.08} />
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 6 — FINAL QUOTE */}
      <section
        className="py-24 md:py-36 bg-ink-surface border-t border-white/10 text-center"
        data-testid="legacy-final-quote"
      >
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <Reveal>
            <p className="font-heading text-3xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-white leading-tight text-balance">
              Basketball is what I coach.{" "}
              <span className="text-burnt">Building people</span> is why I coach.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 text-lg md:text-xl text-zinc-400 max-w-2xl mx-auto leading-relaxed text-balance">
              If the people I coach become better teammates, better leaders, and
              better people because our paths crossed, then I've done my job.
            </p>
          </Reveal>
        </div>
      </section>

      {/* WORK WITH ME — natural invitation */}
      <section
        className="relative py-24 md:py-36 border-t border-white/10 overflow-hidden"
        data-testid="legacy-work-with-me"
      >
        <div className="absolute inset-0 bg-gradient-to-b from-ink-base via-ink-surface to-ink-base" />
        <div className="absolute inset-0 grain opacity-70 hidden md:block" />
        <div className="absolute left-1/2 top-0 -translate-x-1/2 h-px w-40 bg-gradient-to-r from-transparent via-burnt to-transparent" />
        <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-8 text-center">
          <Reveal>
            <p className="label-eyebrow text-gold mb-5">Let's Connect</p>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-white">
              Work With Me
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-7 text-lg md:text-xl text-zinc-400 leading-relaxed text-balance">
              Whether you're a parent, coach, athletic director, or organization,
              I'm always open to conversations about developing athletes, building
              strong team cultures, and creating environments where people can thrive.
            </p>
          </Reveal>
          <Reveal delay={0.16}>
            <Link
              to="/contact"
              data-testid="legacy-contact-cta"
              className="group mt-10 inline-flex items-center gap-2 bg-burnt hover:bg-burnt-hover text-white font-medium px-8 py-4 transition-colors"
            >
              Contact Coach Elete
              <ArrowRight
                size={16}
                className="transition-transform group-hover:translate-x-1"
              />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
